import { Component, Input } from '@angular/core';
import { GrundstueckId } from '../../core/av-api';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { HaengigeGeschaefteAuftraegeComponent } from '../../shared/components/haengige/haengige-geschaefte/haengige-geschaefte-auftraege.component';

@Component({
  selector: 'cap-grundstueck-haengige',
  templateUrl: './grundstueck-haengige.component.html',
  styleUrls: ['./grundstueck-haengige.component.scss'],
  imports: [HaengigeGeschaefteAuftraegeComponent]
})
export class GrundstueckHaengigeComponent {
  @Input()
  loadOption: 'ALLE' | 'HAENGIGE' = 'ALLE';
  @Input()
  hasRight = true;

  grundstueckIds: Array<GrundstueckId>;

  constructor() {
    keysToTranslate<string>(['HAENGIGE', 'ALLE']);
  }

  @Input()
  set grundstueckId(value: GrundstueckId) {
    this.grundstueckIds = new Array<GrundstueckId>();
    this.grundstueckIds.push(value);
  }
}
